import styled from 'styled-components';

import { HTMLAttributes } from 'react';
import media from '../../../utils/styling/media';
import Row from '../../grid/Row';
import Col from '../../grid/Col';
import MainLanguageButton from '../../buttons/MainLanguageButton';

export const StyledLogoCol = styled(Col)`
  display: flex;
`;

export const StyledRightContentCol = styled(Col)`
  z-index: 2;
  display: flex;
`;

export const StyledAppName = styled.span<{
  height?: number;
  horizontalLogo: boolean;
  primary: boolean;
}>`
  display: inline-block;
  height: ${({ theme, height, horizontalLogo }) => height || (
    horizontalLogo ? theme.MainLogoHorizontal?.height : theme.MainLogo.height
  )};
  border-left: 2px solid ${({ theme }) => theme.colors.gray2};
  padding-left: 32px;
  padding-right: 32px;
  margin-left: 32px;
  font-size: 17px;
  color: ${({ theme, primary }) => primary ? theme.colors.white : theme.colors.shadowGray4};
  box-sizing: border-box;
  font-weight: 600;
  line-height: 1.29;
  display: flex;
  align-items: center;

  ${media.lg<{ horizontalLogo: boolean }>`
    height: ${({ theme, horizontalLogo }) => horizontalLogo ? theme.MainLogoHorizontal.height : theme.MainLogo.lgHeight};
  `}
`;

export const StyledMiddleContent = styled.div<{ primary: boolean }>`
  color: ${({ theme, primary }) => primary ? theme.colors.white : theme.colors.shadowGray4};
  font-weight: 600;
  font-size: 17px;
  position: absolute;
  left: 0;
  right: 0;
  text-align: center;
  z-index: 1;
`;

export const StyledCol = styled(Col)`
  z-index: 2;
`;

export const StyledClosedButton = styled.button<{ primary: boolean } & HTMLAttributes<HTMLButtonElement>>`
  display: flex;
  background: transparent;
  border: 0;
  outline: 0;
  cursor: pointer;
  color: ${({ theme, primary }) => primary ? theme.colors.white : theme.colors.light};
  align-items: center;
  margin-right: 10px;

  &:hover {
    color: ${({ theme }) => theme.colors.lighter};
  }

  &:focus-visible, &:focus {
    box-shadow: ${({ theme }) => theme.boxShadows?.focus};
  }

  &:focus:not(&:focus-visible) {
    box-shadow: none;
  }

  &:focus:not(:disabled),
  &:active:not(:disabled) {
    color: ${({ theme }) => theme.colors.lightest};
  }

  ${media.lg`
    margin-right: 0px;
`}

`;

export const StyledCloseIcon = styled.svg`
  margin-left: 8px;

  ${media.lg`
    margin-left:0px;
`}
`;

export const StyledRightRow = styled(Row)`
  align-items: center;
`;

export const StyledMainLanguageButton = styled(MainLanguageButton)`
`;

export const StyledClosedButtonText = styled.span`
  position: absolute;
  left: -1000000px;
  font-size: 14px;
  font-weight: 600;
  padding-right: 6px;

  ${media.lg`
    position: static;
  `}
`;
